import * as React from 'react';

const ShopTimer = props => (
  <svg
    width={45}
    height={48}
    viewBox="0 0 45 48"
    stroke="none"
    strokeWidth={1}
    fill="#F25757"
    fillRule="evenodd"
    {...props}>
    <path
      d="M17.008,4.592 L17.008,2 C17.008,0.895 17.904,0 19.009,0 L25.012,0 C26.117,0 27.013,0.895 27.013,2 L27.013,4.592 C30.304,5.365 33.372,6.886 35.977,9.038 L37.514,7.503 C36.797,6.72 36.822,5.512 37.57,4.759 L38.754,3.575 C39.536,2.795 40.803,2.795 41.584,3.575 L44.414,6.403 C45.195,7.185 45.195,8.451 44.414,9.232 L43.23,10.415 C42.488,11.154 41.301,11.194 40.511,10.506 L38.99,12.027 C45.239,19.61 45.698,30.414 40.115,38.499 C34.532,46.583 24.26,49.987 14.95,46.837 C5.639,43.688 -0.452,34.75 0.026,24.938 C0.504,15.127 7.435,6.822 17.008,4.592 Z"
      opacity={0.200000003}
    />
    <path d="M20.004,32.926 C19.977,33.661 20.353,34.351 20.985,34.727 C21.618,35.102 22.404,35.102 23.036,34.727 C23.669,34.351 24.045,33.661 24.017,32.926 L23.875,29.515 C25.243,28.8 26.074,27.36 26.01,25.819 C25.945,24.278 24.996,22.912 23.573,22.314 L23.014,8.97 C22.99,8.434 22.548,8.012 22.011,8.012 C21.474,8.012 21.032,8.434 21.008,8.97 L20.449,22.313 C19.026,22.912 18.077,24.278 18.013,25.819 C17.948,27.36 18.78,28.8 20.147,29.515 L20.004,32.926 Z" />
    <circle fill="#FFFFFF" cx={22} cy={26} r={2} />
  </svg>
);

export default ShopTimer;



// WEBPACK FOOTER //
// ./src/assets/images/icons/shop-timer.js